import {Game, GameInstanceBase} from "@denishussar/html5-game-engine";
import {ScreenOrientationEnum} from "@denishussar/html5-game-engine";
import {EnvironmentTypeEnum} from "@denishussar/html5-game-engine";
import {GameInstance} from "./Game/GameInstance";

declare var require;

require("../fonts/fonts.css");

const gameCfg =  require('../game-config.json');

const game = new Game({
    main: GameInstance,
    version: "1.0.0",
    sounds:[
        {
            "id": "button_disabled",
            "path": "/sounds/button_disabled.mp3"
        },
        {
            "id": "button",
            "path": "/sounds/button_press.mp3"
        },
        {
            "id": "game_end",
            "path": "/sounds/game_end.mp3"
        },
        {
            "id": "music",
            "path": "/sounds/game_loop.mp3"
        },
        {
            "id": "menu_loop",
            "path": "/sounds/menu_loop.mp3"
        },
        {
            "id": "kykka_hit",
            "path": "/sounds/kykka_hit.mp3"
        },
    ],
    assetsRoot: gameCfg.resourcesRoot,
    elementId: "gamePlace",
    noWebGL: false,
    backgroundColor: 0x89C0FC,
    clearBeforeRender: true,
    transparent: false,
    showStats: false,
    disableContextMenu: true,
    antialias: false,
    fps: 60,
    gameId: gameCfg.gameId,
    orientations: [
        // {
        //     orientation:ScreenOrientationEnum.Portrait,
        //     orientationEnvironment: EnvironmentTypeEnum.phone
        // },
        {
            orientation:ScreenOrientationEnum.PortraitAndLandscape,
            orientationEnvironment: EnvironmentTypeEnum.pc | EnvironmentTypeEnum.tablet | EnvironmentTypeEnum.phone
        }
    ]
});

